<template>
  <!-- <div class="search-container">
    <el-form>

      <el-row :gutter="20" class="search-row">
        <el-col

          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
        >
          <span class="label">Từ ngày</span>
          <el-date-picker v-model="searchInputs.startDate" type="date" />
        </el-col>
        <el-col

          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
        >
          <span class="label">Đến ngày</span>
          <el-date-picker v-model="searchInputs.endDate" type="date" />
        </el-col>
        <el-col

          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
        >
          <span class="label">Đối tượng</span>
          <el-select v-model="searchInputs.objectType">
            <el-option
              v-for="item in objectTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col

          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
        >
          <span class="label" style="width: 120px">Thông tin chính</span>
          <el-input v-model="searchInputs.keyword" style="width: auto !important" type="text" />
        </el-col>
      </el-row>
    </el-form>

  </div> -->
  <div class="search-container">
    <el-form
      label-width="120px"
      label-position="left"
      style="padding-top: 15px"
    >
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="Từ ngày">
            <el-date-picker
              v-model="searchInputs.startDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              type="date"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="Đến ngày">
            <el-date-picker
              v-model="searchInputs.endDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              type="date"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="Đối tượng">
            <el-select v-model="searchInputs.objectType" style="width: 100%">
              <el-option :value="null" label="Tất cả" />
              <el-option
                v-for="item in objectTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="Thông tin chính">
            <el-input v-model="searchInputs.keyword" type="text" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="search-action" type="flex" justify="center">
      <el-button type="primary" @click="onSearch">Tìm kiếm</el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchInputs: {
        // pageSize: 10,
        // pageNum: 1,
        // orderTp: 'ASC',
        keyword: '',
        startDate: null,
        endDate: null,
        objectType: null
        // orderBy: null
      },
      objectTypeOptions: [
        {
          value: 1,
          label: 'Package category'
        },
        {
          value: 2,
          label: 'Package group'
        },
        {
          value: 3,
          label: 'Package'
        },
        {
          value: 4,
          label: 'Package detail'
        }
      ]
    }
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.searchInputs)
    }
  }
}
</script>

<style></style>
